export const documents = {
  description:
    "الرسومات والإجراءات والصور المحفوظة بشكل خاص والقابلة للتتبع عبر سجل التدقيق.",
  column: {
    document: "المستند",
    size: "الحجم",
  },
  uploaded: "تم الرفع",
  by: "بواسطة",
  download: "تنزيل",
  caption: "المستندات المرفقة بـ {ownerType} {ownerId}",
  emptyTitle: "لا توجد مستندات هنا بعد",
  emptyDescription: "ستُعرض الرسومات والصور والإجراءات المرفوعة الخاصة بهذا المرجع هنا.",
  deletedToast: "تم وضع علامة حذف على المستند",
  deletedToastDesc: "{name} (سُجّل السبب في سجل التدقيق)",
  document: "المستند",
  deleteTitle: "حذف {name}؟",
  deleteDescription: "يُحتفظ بالسجل للتاريخ؛ فيما يختفي الملف من القوائم والتنزيلات.",
  confirmDelete: "تأكيد الحذف",
  reasonHint: "مطلوب لسجل التدقيق (3 أحرف على الأقل).",
  filter: {
    attachedTo: "مرفق بـ",
    reference: "المرجع",
    referenceHint: "أحرف وأرقام وشرطة وشرطة سفلية.",
  },
  ownerType: {
    other: "مستندات الورشة العامة",
    customer: "عميل (حسب المرجع)",
    quote: "عرض أسعار (حسب المرجع)",
    job: "أمر عمل (حسب المرجع)",
    purchase_order: "أمر شراء (حسب المرجع)",
    invoice: "فاتورة (حسب المرجع)",
  },
  uploadCard: {
    title: "رفع مستند",
    fileLabel: "الملف (PDF أو PNG أو JPEG أو WEBP — بحد أقصى 10 م.ب)",
    uploading: "جارٍ الرفع…",
    upload: "رفع",
    chooseFirst: "اختر ملف PDF أو PNG أو JPEG أو WEBP أولاً.",
    uploadedToast: "تم رفع المستند",
  },
};
